import { CSSProperties, useEffect, useState } from 'react';
import config from 'src/config';
import { acceptAll, hasChosen, rejectAll } from 'src/modules/consent/consent';

// TODO(i18n): move the copy below into the app's i18n dictionaries.
const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!hasChosen());
  }, []);

  if (!visible) {
    return null;
  }

  const choose = (apply: () => void) => () => {
    apply();
    setVisible(false);
  };

  const privacyUrl =
    config.marketingPrivacyPolicyUrl || 'https://www.soaak.com/privacy-policy';

  return (
    <div role="dialog" aria-label="Cookie consent" style={styles.wrap}>
      <div style={styles.inner}>
        <p style={styles.text}>
          We use cookies for analytics and marketing to improve your experience.
          Accept all, or reject non-essential cookies.{' '}
          <a href={privacyUrl} target="_blank" rel="noreferrer" style={styles.link}>
            Privacy Policy
          </a>
          .
        </p>
        <div style={styles.buttons}>
          <button type="button" onClick={choose(rejectAll)} style={styles.ghost}>
            Reject all
          </button>
          <button type="button" onClick={choose(acceptAll)} style={styles.primary}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, CSSProperties> = {
  wrap: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    background: 'rgba(17,17,17,0.97)',
    borderTop: '1px solid rgba(255,255,255,0.12)',
    padding: '16px',
    color: '#fff',
  },
  inner: {
    maxWidth: 960,
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    flex: '1 1 320px',
    margin: 0,
    fontSize: 13,
    lineHeight: 1.5,
    color: 'rgba(255,255,255,0.85)',
  },
  link: { color: '#fff', textDecoration: 'underline' },
  buttons: { display: 'flex', gap: 8, flexShrink: 0 },
  ghost: {
    padding: '8px 16px',
    fontSize: 13,
    fontWeight: 600,
    color: '#fff',
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.35)',
    borderRadius: 8,
    cursor: 'pointer',
  },
  primary: {
    padding: '8px 16px',
    fontSize: 13,
    fontWeight: 600,
    color: '#111',
    background: '#fff',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
  },
};

export default ConsentBanner;
